<template>
    <div class="container">
        <div class="filter">
            <div class="select">
                <el-select v-model="IncidentClassificationClass">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="select">
                <el-select v-model="identTypeClass" >
                    <el-option
                        v-for="item in options1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="select">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    :default-time="['00:00:00', '23:59:59']"
                    @change="$emit('query', dateRange)">
                </el-date-picker>
            </div>
            <div class="select">
                <el-button type="primary" @click="onSearch">查询</el-button>
            </div>
        </div>
        <div class="count" v-if="this.$route.params.classify=='unconfirmed'">
            <el-button type="" @click="makeSure">一键确认事件</el-button>
        </div>
    </div>
</template>

<script>
    import {
        dateFormat
    } from '../../../util/DateUtil';
export default {
    props: {
        count: Number,
        types: Array,
        classify:String
    },
    data () {
        return {
            // fault: 0  故障报警
            // hiddenDanger: 0  隐患
            // messageNotice: 0 信息通报
            // notice: 7 通知
            // operation: 0  操作命令
            // other: 0  其他
            // overrun: 0 越限异常
            // protections: 0 保护动作
            // sum: 7 总
            // switchDisplacement: 7  开关变位
            // urgent: 0 紧急
            dateRange:"",
            identTypeClass:"",
            IncidentClassificationClass:"",
            grade:[{
                label:"紧急",
                value:"URGENT"
            },{
                label:"隐患",
                value:"HIDDEN_DANGER"
            },{
                label:"通知",
                value:"NOTICE"
            }],
            type:[{
                label:"保护动作",
                value:"PROTECTIONS"
            },{
                label:"故障报警",
                value:"FAULT"
            },{
                label:"开关变位",
                value:"SWITCH_DISPLACEMENT"
            },{
                label:"越限异常",
                value:"OVERRUN"
            },{
                label:"信息通报",
                value:"MESSAGE_NOTICE"
            },{
                label:"操作命令",
                value:"OPERATION"
            },{
                label:"其他告警",
                value:"OTHER"
            }]
        }
    },
    methods:{
        onSearch(){
            let info = {
                start:this.dateRange==''?'':dateFormat("YYYY/mm/dd HH:MM:SS",this.dateRange[0]),
                end:this.dateRange==''?'':dateFormat("YYYY/mm/dd HH:MM:SS",this.dateRange[1]),
                dateRange:this.dateRange,
                identTypeClass:this.identTypeClass,
                IncidentClassificationClass:this.IncidentClassificationClass,
            }
            this.$emit('searchInfo',info)
        },
        makeSure(){
            this.$emit('makeSure',true)
        }
    },
    computed: {
        options: function () {
            let op = this.grade.map(item => {
                return {
                    value: item.value,
                    label: item.label,
                }
            })
            op.unshift({label: '全部等级', value: ''});
            return op;
        },
        options1: function () {
            let op = this.type.map(item => {
                return {
                    value: item.value,
                    label: item.label,
                }
            })
            op.unshift({label: '全部类型', value: ''});
            return op;
        }
    },
    watch: {
        
    }
}
</script>

<style lang="less" scoped>
.container {
    .h(88);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 1px;
    background: white;
}
.filter {
    display: flex;
    padding-left: 24rem;
}
.el-select {
    .w(260);
}
.date-picker {
    // padding-left: 24rem;
}
.select{
    padding-right: 24rem;
}
.button {
    padding-left: 24rem;
}
.count {
    padding-right: 24rem;
    font-size: 18rem;
    font-weight: 500;

    span {
        color: #0D94FF;
    }
}
</style>